//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { TitleSection } from "components/styles";
import { Container, Form } from "../styles";
//#endregion
//#region Components
import Fields from "./Fields/Fields";
import Footer from "./Footer/Footer";
import DialogsActionsResource from "../../Dialogs/DialogsActionsResource/DialogsActionsResource";
//#endregion
//#region Utils
import { GROUP_ROOM_SERVICE_TYPE_ID } from "./utils/constants";
import { FORM_ACTION_ERRORS, RESOURCE_TEXT_LIST } from "views/Recursos/ResourcesLibrary/utils/constants";
import useDialogShowActionResource from "../utils/hooks/useDialogShowActionResource";
import useNameForCreatingResource from "../utils/hooks/useNameForCreatingResource";
import DialogCannotBeDoneAction from "../../Dialogs/DialogCannotBeDoneAction/DialogCannotBeDoneAction";
import { 
    requestDeleteResource,
    requestToggleActivationResource } from "services/resources/library/aboutLibraryResources";
import useForm from "./utils/hooks/useForm";
import DialogErrorForFutureReservationsInDesactivation from "../../Dialogs/DialogErrorForFutureReservationsInDesactivation";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import DialogErrorForFutureReservationsInDeletion from "../../Dialogs/DialogErrorForFutureReservationsInDeletion";
//#endregion

const RESOURCE_GROUP_ROOM_TEXT_LIST = RESOURCE_TEXT_LIST[GROUP_ROOM_SERVICE_TYPE_ID];

const GroupRoomResourceForm = ({
    isAdmin,
    currentCampusFilterId,
    resourceTypeIdToCreate, 
    currentGroupRoomResourceForUpdate,
    show,
    toggleShow, 
    data,
    loadingRequest,
    fillServiceList,
    filtersAreCompleted
}) => {
    const isCreate = !currentGroupRoomResourceForUpdate;
    const { dialogShowDeletionResource, dialogShowToggleActivationResource } = useDialogShowActionResource();
    const dialogErrorForFutureReservationsInDesactivation = useShowDialogAlert();
    const dialogErrorForFutureReservationsInDeletion  = useShowDialogAlert();
    //#region States
    const formHandler = useForm({ 
        currentGroupRoomResourceForUpdate,
        resourceTypeIdToCreate,
        currentCampusFilterId
    });
    const { form, errors, errorTexts } = formHandler;
    const [dialogCannotBeDone, setDialogCannotBeDone] = useState({
        show: false,
        action: ""
    });
    //#endregion
    //#region Effects
    useNameForCreatingResource({
        form,
        isCreate,
        loadingRequest
    });
    //#endregion
    //#region Functions
    const closeFormDialog = () => toggleShow(false);
    const toggleShowDialogCannotBeDone = () => {
        setDialogCannotBeDone(prev => ({
            ...prev,
            show: !prev.show
        }));
    }
    const toggleActivationResource = async textList => {
        loadingRequest.show(`${textList.loading} ${RESOURCE_GROUP_ROOM_TEXT_LIST.minus.singular}...`);
        // Realizando petición de activación o desactivación
        const { id, name, active } = form.value;
        const { success, message } = await requestToggleActivationResource({
            resourceId: id,
            active
        });
        // Gestionando respuesta
        if (success) {
            // Exitosa
            closeFormDialog();
            fillServiceList({
                messageForToast: `¡${textList.success} con éxito la ${name}!`
            });
            return;
        }
        cancelToggleActivationResource();
        // Fallida
        loadingRequest.hide();
        switch (message) {
            case FORM_ACTION_ERRORS.FUTURE_RESERVATIONS:
                dialogErrorForFutureReservationsInDesactivation.open();
                return;
            default:
                setDialogCannotBeDone({
                    show: true,
                    action: "desactivar"
                });
        }
    }
    const deleteResource = async reasonForDeletion => {
        loadingRequest.show(`Eliminando ${RESOURCE_GROUP_ROOM_TEXT_LIST.minus.singular}...`);
        const { id, name } = form.value;
        const { success, message } = await requestDeleteResource({
            resourceId: id,
            reasonForDeletion
        });
        if (success) {
            // Exitosa
            closeFormDialog();
            fillServiceList({
                messageForToast: `¡El servicio ${name} fue eliminado existosamente!`
            });
            return;
        }
        // Fallida
        loadingRequest.hide();
        switch (message) {
            case FORM_ACTION_ERRORS.FUTURE_RESERVATIONS:
                dialogErrorForFutureReservationsInDeletion.open();
                return;
            default:
                setDialogCannotBeDone({
                    show: true,
                    action: "eliminar"
                });
        }
    }
    const cancelToggleActivationResource = () => {
        form.change("active", prev => !prev);
        dialogShowToggleActivationResource.toggle(false);
    }
    //#endregion
    return (
        <>
        <Container>
            <TitleSection fontWeight="900">
                {isCreate ? "Registrar" : "Editar"} Recurso
            </TitleSection>
            <Form onSubmit={e => e.preventDefault()}>
                <Fields 
                    isAdmin={isAdmin}
                    setCurrentResourceTypeIdToForm={resourceTypeIdToCreate.set}
                    currentGroupRoomResourceForUpdate={currentGroupRoomResourceForUpdate}
                    toggleShowDialogToggleActivationResource={dialogShowToggleActivationResource.toggle}
                    data={data}
                    {...formHandler}
                    isCreate={isCreate}
                    loadingRequest={loadingRequest}/>
                <Footer 
                    isAdmin={isAdmin}
                    closeFormDialog={closeFormDialog}
                    toggleShowDialogDeletionResource={dialogShowDeletionResource.toggle}
                    form={form}
                    errors={errors}
                    changeErrorTexts={errorTexts.change}
                    loadingRequest={loadingRequest}
                    filtersAreCompleted={filtersAreCompleted}
                    fillServiceList={fillServiceList}
                    isCreate={isCreate}/>
            </Form>
        </Container>
        {(!isCreate && show) && 
        <>
        <DialogsActionsResource
            isResourceActive={form.value.active}
            showDialogsActionResource={{
                dialogShowDeletionResource,
                dialogShowToggleActivationResource
            }}
            actions={{
                cancelToggleActivationResource,
                toggleActivationResource,
                deleteResource
            }}
            data={{
                serviceName: form.value.name,
                serviceTypeName: RESOURCE_GROUP_ROOM_TEXT_LIST.minus.singular
            }}/>
        <DialogCannotBeDoneAction 
            action={dialogCannotBeDone.action}
            resourceName={form.value.name} 
            show={dialogCannotBeDone.show} 
            toggleShow={toggleShowDialogCannotBeDone}/>
        <DialogErrorForFutureReservationsInDesactivation
            dialog={dialogErrorForFutureReservationsInDesactivation}/>
        <DialogErrorForFutureReservationsInDeletion
            dialog={dialogErrorForFutureReservationsInDeletion}/>
        </>}
        </>
    );
}

export default GroupRoomResourceForm;